export default class ShopMenu extends HTMLElement {
  open: boolean = false
  menuEl: HTMLElement | null = null

  constructor() {
    super()

    this.menuEl = this.querySelector<HTMLElement>('aside[data-menu-drawer]') as HTMLElement

    (window as any).addEventListener('menu:toggle', this.handleMenu.bind(this))
  }

  connectedCallback() {
    console.log('Menu added')
  }

  get isOpen() {
    return this.open
  }

  set isOpen(value: boolean) {
    this.open = value
    this.setAttribute('open', value.toString())
    this.toggle()
  }

  handleMenu(evt: CustomEvent) {
    // @ts-ignore
    this.isOpen = evt.detail.open
  }

  toggle() {
    if (this.isOpen) {
      this.menuEl?.classList.add('translate-y-[44px]!')
    } else {
      this.menuEl?.classList.remove('translate-y-[44px]!')
    }
  }
}

customElements.define('shop-menu', ShopMenu)
